import { render, staticRenderFns } from "./firstpageloadtime.vue?vue&type=template&id=54745d95&scoped=true&"
import script from "./firstpageloadtime.vue?vue&type=script&lang=js&"
export * from "./firstpageloadtime.vue?vue&type=script&lang=js&"
import style0 from "./firstpageloadtime.vue?vue&type=style&index=0&id=54745d95&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54745d95",
  null
  
)

export default component.exports